// extracted by mini-css-extract-plugin
module.exports = {"textWithIcon":"_1Z8FV","primary":"Ra36Y","icon":"_3-xn0","secondary":"_3YMwg","padding":"Yuw2K","click":"VUzoN"};